
import React, { ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import AuthHeader from './AuthHeader';

interface AuthCardProps {
  children: ReactNode;
  mode: 'magiclink' | 'signup' | 'verification';
}

const AuthCard = ({ children, mode }: AuthCardProps) => {
  let title = 'Sign In';
  let description = 'Sign in to your existing account.';
  
  if (mode === 'signup') {
    title = 'Create an Account';
    description = 'Fill out the form below to create your account.';
  } else if (mode === 'verification') {
    title = 'Authentication';
    description = 'Complete your authentication process.';
  }
  
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md">
        <AuthHeader title={title} description={description} />
        <CardContent>
          {children}
        </CardContent>
      </Card>
    </div>
  );
};

export default AuthCard;
